import tpl from './next-times-wrapper.tpl.html';
import './next-times-wrapper.component.scss';

import nextTimesMod from './next-times.module';
import keepaliveServiceMod from '../common/keepalive/keepalive.service';
import maintenancePlaceholderComponentMod from '../common/keepalive/maintenance-placeholder.component';

/**
 * This component wraps the next-times component so that it is only loaded when maintenance status has been set. This is
 * to prevent useless requests.
 */
class NextTimesWrapperComponent {
  constructor($timeout, KeepaliveService) {
    'ngInject';

    this.personId = null;
    this.locationId = null;
    this.serviceId = null;
    this.cityId = null;
    this.timeAmount = null;
    this.voucher = null;

    /**
     * Type of the next-times element to render. Leave unset to use basic next-times.
     * @type {?string}
     */
    this.pType = null;

    /**
     * Are we viewing the frontpage?
     * @type {boolean}
     */
    this.isFrontpage = false;

    // Start as null and keep content hidden until status arrives
    this._maintenanceOn = null;
    this._maintenanceNotify = status => $timeout(() => this._maintenanceOn = status);
    KeepaliveService.subscribeMaintenance(this._maintenanceNotify);
  }
}

const config = {
  templateUrl: tpl,
  controller: NextTimesWrapperComponent,
  bindings: {
    // Some of these should be given based on the type
    personId: '<?',
    locationId: '<?',
    cityId: '<?',
    serviceId: '<?',
    timeAmount: '<?',
    pType: '@?',
    isFrontpage: '<?',
    voucher: '@?',
  }
};

const mod = angular.module('app.nextTimes.nextTimesWrapper', [
  nextTimesMod,
  keepaliveServiceMod,
  maintenancePlaceholderComponentMod,
])

.component('nextTimesWrapper', config);

export default mod.name;
